import { apiClient } from '@/api/client';
import { ENDPOINTS } from '@/api/endpoints';

export const getCleanerProfile = async () => {
  return await apiClient.get(`${ENDPOINTS.CLEANERS}/profile`);
};
